import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#0597A3" d="M98.76 28.72a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="m110.69 49.16 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM54.94 96.19a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M18.88 16.37h-5.57V10.8c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H4.74c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M28.07 106.58c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M91.53 42.78c0-1.01-.5-1.89-1.26-2.44L78.26 25.66a3 3 0 0 0-4.64 3.8l8.44 10.32H27.47c-1.66 0-3 1.34-3 3s1.34 3 3 3h54.79l-8.62 10.29a3 3 0 0 0 .38 4.23 2.993 2.993 0 0 0 4.22-.37l12.59-15.04c.49-.58.71-1.3.69-2.02v-.08z"
    />
    <path
      fill="#001A43"
      d="M88.53 70.22H33.74l8.62-10.29c1.06-1.27.9-3.16-.37-4.23a3.01 3.01 0 0 0-4.23.37L25.17 71.11c-.49.58-.71 1.3-.69 2.02v.09c0 1.01.5 1.89 1.26 2.44l12.01 14.68c.59.73 1.45 1.1 2.32 1.1a3 3 0 0 0 2.32-4.9l-8.44-10.32h54.59c1.66 0 3-1.34 3-3s-1.34-3-3-3z"
    />
  </svg>
);
const SvgEnrichedIconTransferInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconTransferInverted);
export default Memo;
